<!------------------------------------------------card content-------------------------->
<div class="changepassword-page">
  <mat-card class="mat-elevation-z12">
    <br>
      <mat-error class="service-errors">{{serviceError}}</mat-error>
      <mat-card-content>
        <form [formGroup]="cpForm" (ngSubmit)="update()">
          @if (successMsg) {
            <div id="success" class="text-center">
              <span>{{successMsg}}</span>
            </div>
          }
          <mat-form-field>
            <input type="password" matInput placeholder="Old Password" formControlName="currentPassword"/>
            <mat-icon matSuffix>lock</mat-icon>
            @if (cpForm.get('currentPassword').invalid && (cpForm.get('currentPassword').dirty || cpForm.get('currentPassword').touched)) {
              <mat-error>
                @if (cpForm.get('currentPassword').errors?.required) {
                  <span>Password is required</span>
                }
                @if (cpForm.get('currentPassword').errors?.missingNumber) {
                  <span>Password must have a atleast one digit</span>
                }
                @if (cpForm.get('currentPassword').errors?.missingUpperCase) {
                  <span>Password must have a atleast one uppercase letter</span>
                }
                @if (cpForm.get('currentPassword').errors?.missingLowerCase) {
                  <span>Password must have a atleast one lowercase letter</span>
                }
                @if (cpForm.get('currentPassword').errors?.missingMinLength) {
                  <span>Password must have a atleast 8 character</span>
                }
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <input type="password" matInput placeholder="New Password" formControlName="newPassword" [errorStateMatcher]="matcher1"/>
            <mat-icon matSuffix>lock</mat-icon>
            <mat-error>
              @if (cpForm.get('newPassword').errors?.required) {
                <span>Password is required</span>
              }
              @if (cpForm.get('newPassword').errors?.missingNumber) {
                <span>Password must have a atleast one digit</span>
              }
              @if (cpForm.get('newPassword').errors?.missingUpperCase) {
                <span>Password must have a atleast one uppercase letter</span>
              }
              @if (cpForm.get('newPassword').errors?.missingLowerCase) {
                <span>Password must have a atleast one lowercase letter</span>
              }
              @if (cpForm.get('newPassword').errors?.missingMinLength) {
                <span>Password must have a atleast 8 character</span>
              }
              @if (cpForm.get('newPassword').valid && cpForm.errors?.newPassword) {
                <span>Old Password and New Password should not be same</span>
              }
            </mat-error>
          </mat-form-field>
          <mat-form-field>
            <input type="password" matInput placeholder="Confirm Password" formControlName="confirmPassword" [errorStateMatcher]="matcher2"/>
            <mat-icon matSuffix>lock</mat-icon>
            <mat-error>
              @if (cpForm.get('confirmPassword').errors?.required) {
                <span>Confirm Password is required</span>
              }
              @if (cpForm.get('confirmPassword').errors?.missingNumber) {
                <span>Password must have a atleast one digit</span>
              }
              @if (cpForm.get('confirmPassword').errors?.missingUpperCase) {
                <span>Password must have a atleast one uppercase letter</span>
              }
              @if (cpForm.get('confirmPassword').errors?.missingLowerCase) {
                <span>Password must have a atleast one lowercase letter</span>
              }
              @if (cpForm.get('confirmPassword').errors?.missingMinLength) {
                <span>Password must have a atleast 8 character</span>
              }
              @if (cpForm.get('confirmPassword').valid && cpForm.errors?.confirmPassword) {
                <span>Password and Confirm Password should be same</span>
              }
            </mat-error>
          </mat-form-field>
          <button type="submit" mat-raised-button class="login-button" [disabled]="!cpForm.valid">Update Password</button>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
  <!-------------------------------------------------end card content---------------------->
